import { produce } from "immer";
import Actions from "../actions";

const initialState = {
  offerList: {},
  selectedOfferId: "",
  offer: {},
  selectedOffersAndPackagesSponsorshipDetails: {},
};

export const offerByID = (selectedOfferId) => ({
  type: Actions.SELECTED_OFFER_ID,
  payload: selectedOfferId,
});
const offers = produce((draft = initialState, action) => {
  const { payload } = action;
  switch (action.type) {
    case Actions.GET_OFFER_LIST: {
      draft.offerList = payload;
      break;
    }
    case Actions.SELECTED_OFFER_ID: {
      draft.selectedOfferId = payload;
      break;
    }

    case Actions.GET_OFFER_BY_ID: {
      draft.offer = payload;
      break;
    }
    case Actions.SELECTED_OFFERS_AND_PACKAGES_SPONSORSHIP_DETAILS: {
      draft.selectedOffersAndPackagesSponsorshipDetails =
        payload?.selectedOffersAndPackagesSponsorshipDetails;
      break;
    }

    default: {
      break;
    }
  }
}, initialState);

export default offers;
